import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import CheckboxInput from 'screens/extra-practice/filter/filter-checkbox';

import { Col, Row, TextInput, Button, Separator } from '@cuemath/comps';
import { Header } from 'semantic-ui-react';
import { HeaderHead } from 'modules/form';
import { closeModal } from 'actions/modal';

const FilterButton = styled(Button)`
  position: relative;
  margin-left: 10px;
  border-radius: 28px;
`;

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 0px 10px 10px 10px;
  margin-top: 10px;
  bottom: 7px;
  position: relative;
`;

const SearchStyle = styled(TextInput)`
  position: relative;
  background: #f7f7fa;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 12px;
  width: 400px;
`;

class SearchFilterModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filterSearchText: null,
      selectedFilters: [],
      selectedObj: null,
      searchResult: {},
    };
  }

  componentDidMount() {
    this.filterModalOpened();
  }

  onApplyFilterClicked = obj => {
    const { handleFilterChange } = this.props;

    this.setState({
      selectedFilters: [],
      filterSearchText: null,
    });

    this.filterModalClosed();

    handleFilterChange(obj, true);
  };

  onModalFilterClicked = value => {
    const { getFilterData, filterType } = this.props;

    const { selectedFilters } = this.state;

    const objSearch = {
      selectedFilters: selectedFilters,
      filter: filterType,
      value,
    };
    const searchData = getFilterData(objSearch);

    if (searchData && Object.keys(searchData).length > 0) {
      this.setState({
        selectedFilters: searchData.obj,
        searchResult: searchData.search,
      });
    }
  };

  filterModalOpened = () => {
    const { selectedFilters } = this.state;
    const { defaultFilters } = this.props;

    const allSelectedFilters = [...defaultFilters, ...selectedFilters];

    this.setState({
      selectedFilters: allSelectedFilters,
    });
  };

  handleSearch = (searchText, opt) => {
    const { options } = this.props;

    let optionsArr = [];

    if (!searchText) {
      optionsArr = options;
    } else {
      optionsArr = opt;
    }

    const topics = this.addSelectedArr(optionsArr);

    this.setState({ topicSearchText: searchText, topicOptions: topics });
  };

  addSelectedArr = options => {
    const { selectedFilters } = this.state;
    let selected = [];

    const selectedArr =
      selectedFilters &&
      selectedFilters.length > 0 &&
      selectedFilters.forEach(id => {
        return options.filter(opt => opt.id === id);
      });
    selected =
      selectedArr && selectedArr.length > 0
        ? [...selectedArr, ...selectedFilters]
        : options;

    return selected;
  };

  filterItems = searchText => {
    const { selectedFilters } = this.state;
    const { options } = this.props;

    let filteredArr;

    if (selectedFilters && selectedFilters.length) {
      selectedFilters.forEach(id => {
        filteredArr = options.filter(item => {
          if (searchText === '') {
            return [];
          }

          return (
            id === item.id ||
            item.value.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())
          );
        });
      });
    } else {
      filteredArr = options.filter(item => {
        if (searchText === '') {
          return [];
        }

        return item.value.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
      });
    }

    return filteredArr;
  };

  renderFormHeader = () => {
    return (
      <HeaderHeadWrapper>
        <Header as="h3" floated="left">
          <Separator height={5} transparent />
          Search Filters
        </Header>
      </HeaderHeadWrapper>
    );
  };

  filterModalClosed = () => {
    const { actions, getFilteredPrograms } = this.props;

    getFilteredPrograms();

    actions.closeModal();
  };

  render() {
    const { topicSearchText, selectedFilters, searchResult } = this.state;
    const { options } = this.props;

    const filteredOptions = topicSearchText ? this.filterItems(topicSearchText) : options;

    const optionsFilter = !filteredOptions ? options : filteredOptions;

    const searchObj = {
      obj: selectedFilters,
      search: searchResult,
      isModalValues: true,
    };

    return (
      <Row justifyContent="center">
        <Separator height={10} transparent />
        {this.renderFormHeader()}
        <Separator height={20} transparent />
        <Col>
          <Separator height={20} transparent />
          <Separator height={10} transparent />
          <SearchStyle
            name="topicSearch"
            type="search"
            placeholder="Search"
            onChange={v => {
              this.handleSearch(v, optionsFilter);
            }}
          />
          <CheckboxInput
            options={optionsFilter || []}
            name="Topic"
            onChange={id => this.onModalFilterClicked(id, true)}
            selected={selectedFilters || []}
            width="25em"
          />
          <Separator height={20} transparent />
          <FilterButton
            label="Apply filters"
            onClick={() => this.onApplyFilterClicked(searchObj)}
          />
          <Separator height={20} transparent />
        </Col>
      </Row>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      closeModal,
    },
    dispatch,
  ),
}))(SearchFilterModal);
